<app-container>
  <app-header-meta-action title="Firmen und Personen">
    <div class="relative max-w-96">
      <input appTailwindInput2 type="text" (input)="setFilterValue($event)" />
      <div
        class="absolute inset-y-0 right-0 mr-2 flex items-center pointer-events-none text-fg-muted"
      >
        <app-ng-icon class="text-2xl" name="heroMagnifyingGlass"></app-ng-icon>
      </div>
    </div>
    <app-dropdown-minimal-menu>
      <app-dropdown-button>
        <button appTailwindButton type="button">Firma oder Person anlegen</button>
      </app-dropdown-button>
      <app-dropdown-item (menuClick)="createCustomer('company')">Firma anlegen</app-dropdown-item>
      <app-dropdown-item (menuClick)="createCustomer('individual')"
        >Person anlegen
      </app-dropdown-item>
    </app-dropdown-minimal-menu>
  </app-header-meta-action>

  <!--  <app-wide-list [listEntries]="customers$ | async"></app-wide-list>-->
  @if (filteredCustomers$ | async; as customers) {
    @if (customers.length > 0) {
      <div class="mt-4 bg-surface shadow overflow-hidden sm:rounded-md">
        <ul>
          @for (customer of customers; track customer.id; let isFirst = $first) {
            <li
              app-customer-list-entry
              [customer]="customer"
              [ngClass]="{ 'border-t border-edge': !isFirst }"
            ></li>
          }
        </ul>
      </div>
    } @else {
      <app-empty
        message="Lege deine erste Firma an."
        (buttonClick)="createCustomer('company')"
      ></app-empty>
      <app-empty
        message="Oder eine Person?"
        (buttonClick)="createCustomer('individual')"
      ></app-empty>
    }
  }
</app-container>
